import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import OpacityInput from './';

function OpacityInputReact(props) {

  var containerReference = useRef(null);
  var opacityInputReference = useRef(null);

  useEffect(function onMount() {

    var container = containerReference.current;

    var opacityInput = new OpacityInput({
      opacity: props.opacity,
      onChange: props.onChange
    });

    opacityInputReference.current = opacityInput;

    mount(container, opacityInput);

    return function onUnmount() {
      unmount(container, opacityInputReference.current);
    };

  }, []);

  useEffect(function onOpacityChange() {

    if (opacityInputReference.current === null) {
      return;
    }

    opacityInputReference.current.update({
      opacity: props.opacity,
      onChange: props.onChange
    });

  }, [props.opacity, props.onChange]);

  function renderMain() {

    return <div className="opacity-input-react-wrapper" ref={containerReference}></div>;

  }

  return renderMain();

}

export default OpacityInputReact;
